import {
  SummaryState,
  SummaryVuexState,
  SummaryStateKeys,
} from '@/@types/billing/summary/index'

const claimState = (): SummaryVuexState => ({
  data: {
    municipalitiesNo: '',
    nowDate: '',
    to: '',
    billingOfficeNumber: '',
    billingOfficeZip: '',
    billingOfficeAddress: '',
    billingOfficeTel: '',
    billingOfficeName: '',
    billingName: '',
    date: '',
    billingAmount: '',
    dc: [],
    ad: [],
    subTotal: {
      classCount: '',
      classUnits: '',
      classTotalAmount: '',
      classBillingAmount: '',
      classUbCost: '',
      classGrantMunicipalAmount: '',
    },
    sa: {
      classCount: '',
      classTotalAmount: '',
      classBillingAmount: '',
      classGrantMunicipalAmount: '',
    },
    total: {
      classCount: '',
      classUnits: '',
      classTotalAmount: '',
      classBillingAmount: '',
      classUbCost: '',
      classGrantMunicipalAmount: '',
    },
    isUpperLimitNotServiceHide: 1,
  },
})

export default {
  namespaced: true,
  state: claimState(),
  mutations: {
    valueResetSet(state: SummaryVuexState) {
      state.data = {}
    },
    valueSet(state: SummaryVuexState, value: SummaryState) {
      state.data = value
    },
    valueTargetSet(
      state: SummaryVuexState,
      value: {
        key: SummaryStateKeys
        value: string | number
      }
    ) {
      switch (value.key) {
        case 'isUpperLimitNotServiceHide':
          state.data[value.key] = Number(value.value)
          break
      }
    },
  },
}
